import { defineComponent as o, createElementBlock as r, openBlock as s, createVNode as n, renderSlot as t, unref as a, mergeProps as l, withCtx as u } from "vue";
import { RevButtonBase as c } from "@ds/components/ButtonBase";
const i = { class: "rounded-sm relative size-64 border" }, _ = /* @__PURE__ */ o({
  name: "DocumentSmallBase",
  __name: "DocumentSmallBase",
  props: {
    buttonAttrs: {}
  },
  setup(m) {
    return (e, d) => (s(), r("article", i, [
      n(a(c), l(e.buttonAttrs, { class: "focus-visible-outline-default-hi inline-block overflow-hidden rounded-[calc(0.375rem-1px)]" }), {
        default: u(() => [
          t(e.$slots, "default")
        ]),
        _: 3
      }, 16),
      t(e.$slots, "avatar")
    ]));
  }
});
export {
  _ as default
};
